import { AutoplayDetection } from './autoplay-detection';
import { CanAutoPlayResult, CanAutoplay } from './can-autoplay';

/**
 * Safari is very restrictive regarding autoplay policies.
 *
 * Since autoplay restrictions are granted on a per-element basis, we use
 * the same video element as for the content.
 * A newly created and/or unattached video element may behave differently.
 *
 * Additionally, we add the `autoplay` and `playsinline` attributes to the video element.
 * For macOS and iOS, `autoplay` only works if the `playsinline` is also set.
 * `playsinline` also prevents Mobile Safari from entering the native fullscreen mode, which
 * cannot be closed automatically.
 *
 * Note: The attributes will not be removed after the autoplay check except for the
 * autoplay attribute
 */
export class SafariAutoplayDetection extends AutoplayDetection {
  private readonly canAutoplay: CanAutoplay;

  constructor() {
    super();
    this.canAutoplay = new CanAutoplay();
  }

  protected async isAutoplaySupportedForPlatform(
    videoElement: HTMLVideoElement,
    isMuted: boolean,
  ): Promise<CanAutoPlayResult> {
    this.log.debug('Autoplay Detection on Safari');

    videoElement.muted = isMuted;
    videoElement.autoplay = true;
    videoElement.playsInline = true;

    const result = await this.canAutoplay.video(videoElement);

    videoElement.autoplay = false;

    return result;
  }
}
